import { render, staticRenderFns } from "./ModalInfoPedido.vue?vue&type=template&id=4f633b63&scoped=true&"
import script from "./ModalInfoPedido.vue?vue&type=script&lang=js&"
export * from "./ModalInfoPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f633b63",
  null
  
)

export default component.exports